import React, { Component } from "react";

import { BsyUtils } from "../../../utils/Utils";

import "./index.css";
import BsySLoading from "../../BsySLoading";
import BsySearchInput from "../../BsySearchInput";
import tipAlert from "../../../Login/BsyAlertTip/Staticize";

export const FAVORITES_MAX = 50;

export default class BsyDashboardMyFavoritesConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apps: [],
      appMaps: {},
      favorites: [...(props.favorites || [])],
      key: "",
      seachList: [],
      seachApps: [],
      seachEntrys: [],
      seachDashs: [],
      isLoading: false,
    };
  }

  getAppList = () => {
    React.axios("/dashboard/app_group/list")
      .then((res) => {
        if (res.data.code === 0) {
          this.setState(
            {
              apps: [...res.data.items],
            },
            () => {
              // this.onSelectApp(this.state.appid);
            }
          );
        } else {
          BsyUtils.showAjaxTip(res.data, () => {
            this.setState(
              {
                apps: [...res.data.items],
              },
              () => {
                // this.onSelectApp(this.state.appid);
              }
            );
          });
        }
      })
      .catch((res) => {});
  };
  componentDidMount() {
    this.getAppList();
  }

  entryClick = (e) => {
    e.stopPropagation();
  };

  onSelectApp = (_id) => {
    const { appMaps } = this.state;
    if (!_id) {
      return;
    }
    if (appMaps[_id]) {
      const newAppMap = {
        ...appMaps,
        [_id]: { ...appMaps[_id], open: !appMaps[_id].open },
      };
      this.setState({
        appMaps: newAppMap,
      });
      return;
    }
    this.setState({
      isLoading: true,
    });
    React.axios("/dashboard/app/" + _id, {})
      .then((res) => {
        let entrys = [];
        window.FX.STATIC.user.dock_userid = res.data.dock_userid;
        res.data.entryList.map((data, index) => {
          if (data.child) {
            BsyUtils.forEach(data.child, (index, childdata) => {
              entrys.push({ ...res.data.entryMap[childdata.id], appId: _id });
              if(childdata.child){
                BsyUtils.forEach(childdata.child, (index, childdata1) => {
                  entrys.push({ ...res.data.entryMap[childdata1.id], appId: _id });
                });
              }
            });
            // data.child.map((childdata, index) => {
            //     entrys.push({ ...res.data.entryMap[childdata.id], appId: _id })
            // })
          } else {
            entrys.push({ ...res.data.entryMap[data.id], appId: _id });
          }
          return null;
        });
        const newAppMap = {
          [_id]: { ...res.data, entrys: entrys, open: true },
          ...appMaps,
        };
        this.setState({
          appMaps: newAppMap,
          isLoading: false,
        });
      })
      .catch((res) => {
        this.setState({
          isLoading: false,
        });
      });
  };

  getSearchValue = (ref) => {
    this.searchValue = ref;
  };

  onSearch = () => {
    let key = this.searchValue.getValue();
    if (!key) {
      this.setState({
        key: "",
        seachList: [],
        seachApps: [],
        seachEntrys: [],
        seachDashs: [],
      });
      return;
    }
    React.axios("/dashboard/search", {
      keyword: key,
      type: "all",
      mode: "all",
      range: "noStandard",
    })
      .then((res) => {
        let apps = [];
        let entrys = [];
        let dashs = [];
        if (res.data.list && res.data.list.length > 0) {
          res.data.list.map((val) => {
            if (val.type === "app") {
              apps.push(val);
            } else if (val.type === "form") {
              entrys.push(val);
            } else {
              dashs.push(val);
            }
            return null;
          });
        }

        this.setState({
          key: this.searchValue.getValue(),
          seachList: res.data.list,
          seachApps: apps,
          seachEntrys: entrys,
          seachDashs: dashs,
        });
      })
      .catch((res) => {
        console.error(res);
      });
  };
  findEntryWidget = (block) => {
    const { favorites } = this.state;
    const blockdata = block?.value || block;
    let widget = favorites.filter((value) => {
      const { value: data } = value;
      if (
        [data.appId, data.entryId || ""].join("@") ===
        [blockdata.appId || blockdata._id, blockdata.entryId || ""].join("@")
      ) {
        return true;
      }
      return false;
    });
    return widget.length > 0;
  };

  getValue = () => {
    const { favorites } = this.state;
    if (this.props.getValue) {
      this.props.getValue([...favorites]);
    }
  };

  renderEntryList = (appInfo) => {

    const { appMaps } = this.state;
    if (appMaps[appInfo._id]) {
      if (!appMaps[appInfo._id].open) {
        return "";
      }

      let { entrys } = appMaps[appInfo._id];
      let entrysFilter = entrys.filter((item)=>{
        return  ["dash","form"].includes(item.type)
      })
      return (
        <div className="app-entrys">
          {entrysFilter.length === 0 ? (
            <div className="entry-item-title empty">
              <span className="entry-title">当前应用没有可使用报表</span>
            </div>
          ) : (
            entrysFilter.map((data, index) => {
              return (
                <>
                  <div
                    key={`entry-${data.entryId}-${data.appId}`}
                    className={"entry-item-title"}
                     onClick={(e) => {
                        e.stopPropagation();
                        this.onSelectEntry(data);
                      }}
                  >
                    <div className="left-entry">
                      <i
                        className={"entry-icon " + BsyUtils.getFormIcon(data)}
                      />
                      <span className={"entry-title"}>{data.name}</span>
                    </div>
                    <span
                      className={"right-entry-title"}
                     
                    >
                      {this.findEntryWidget(data) ? (
                        <i className="icon-bsy-select" />
                      ) : (
                        <i className="icon-bsy-check2" />
                      )}
                    </span>
                  </div>
                </>
              );
            })
          )}
        </div>
      );
    } else {
      return "";
    }
  };

  renderApplist = () => {
    const { apps } = this.state;
    let that = this;

    return (
      <>
        {apps.map((data) => {
          return data.apps.map((appdata) => {
            return (
              <div className={"applist-item "} key={`app-${appdata._id}`}>
                <div
                  className="app-title"
                  onClick={(e) => {
                    that.onSelectApp(appdata._id);
                  }}
                >
                  <div className="left-entry">
                    <div
                      className={"app-icon color-cover-" + appdata.style.color}
                    >
                      <div
                        className={
                          "imgbg-bsy-app imgbg-bsy-app-" + appdata.style.icon
                        }
                      />
                    </div>
                    <span>{appdata.appname}</span>
                  </div>
                  <span
                    className={"right-entry-title"}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.onSelectEntry(appdata);
                    }}
                  >
                    {this.findEntryWidget(appdata) ? (
                      <i className="icon-bsy-select" />
                    ) : (
                      <i className="icon-bsy-check2" />
                    )}
                  </span>
                </div>
                {this.renderEntryList(appdata)}
              </div>
            );
          });
        })}
      </>
    );
  };

  onSelectEntry = (data) => {
    const { favorites } = this.state;
    const entryData = data.entryId
      ? {
          type: "entry",
          isValid: false, //是否失效 false为失效
          value: {
            _id: data._id,
            appId: data.appId,
            entryId: data.entryId,
            type: data.type,
            name: data.name,
            hasCoop: data.hasCoop,
            icon: data.icon,
          },
        }
      : {
          type: "app",
          isValid: false,
          value: {
            appId: data._id,
            appname: data.appname,
            style: {
              color: data.style.color,
              icon: data.style.icon,
            },
          },
        };

    let r = this.findEntryWidget(entryData);

    if (!r) {
      if (favorites.length >= FAVORITES_MAX) {
        tipAlert({
          msg: React.language("add.max.count.tip", {
            count: FAVORITES_MAX,
          }),
          type: "warning",
        });
        return;
      }
    }

    this.setState(
      {
        favorites: r
          ? favorites.filter((value) => {
              if (value.type === "app" && entryData.type === "app") {
                return value.value.appId !== entryData.value.appId;
              }
              if (value.type === "entry" && entryData.type === "entry") {
                return (
                  [value.value.appId, value.value.entryId].join("@") !==
                  [entryData.value.appId, entryData.value.entryId].join("@")
                );
              }
              return true;
            })
          : [...favorites, entryData],
      },
      () => {
        this.getValue();
      }
    );
  };

  renderSeachlist = () => {
    const { seachList, seachApps, seachEntrys, seachDashs } = this.state;

    return (
      <div className="app-seach-list">
        {seachList.length === 0 ? (
          <div className="entry-item-title empty">
            <span className="entry-title">未搜索到可使用应用或表单</span>
          </div>
        ) : (
          <>
            {seachApps.length > 0 && (
              <div className="entry-item-title">
                <span
                  className="entry-title"
                  style={{
                    paddingLeft: "20px",
                    height: "36px",
                    lineHeight: "36px",
                  }}
                >
                  {React.language("app")}
                </span>
                {seachApps.map((appdata) => {
                  return (
                    <div
                      className={"applist-item "}
                      key={`seach-app-${appdata._id}`}
                    >
                      <div className="app-title">
                        <div className="left-entry">
                          <div
                            className={
                              "app-icon color-cover-" + appdata.style.color
                            }
                          >
                            <div
                              className={
                                "imgbg-bsy-app imgbg-bsy-app-" +
                                appdata.style.icon
                              }
                            />
                          </div>
                          <span
                            className={"entry-title"}
                            dangerouslySetInnerHTML={{
                              __html: appdata.appname
                                .split(this.state.key)
                                .map((val) => {
                                  return val;
                                })
                                .join(
                                  '<span style="color: #0265FF;">' +
                                    this.state.key +
                                    "</span>"
                                ),
                            }}
                          ></span>
                        </div>
                        <span
                          className={"right-entry-title"}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.onSelectEntry(appdata);
                          }}
                        >
                          {this.findEntryWidget(appdata) ? (
                            <i className="icon-bsy-select" />
                          ) : (
                            <i className="icon-bsy-check2" />
                          )}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            {seachEntrys.length > 0 && (
              <div className="entry-item-title">
                <span
                  className="entry-title"
                  style={{
                    paddingLeft: "20px",
                    height: "36px",
                    lineHeight: "36px",
                  }}
                >
                  {React.language("form")}
                </span>

                {seachEntrys.map((data) => {
                  return (
                    <div
                      className={"applist-item "}
                      key={`seach-form-${data._id}`}
                    >
                      <div className="app-title">
                        <div className="left-entry">
                          <i
                            className={
                              "entry-icon " + BsyUtils.getFormIcon(data)
                            }
                          />
                          <span
                            className={"entry-title"}
                            dangerouslySetInnerHTML={{
                              __html: data.name
                                .split(this.state.key)
                                .map((val) => {
                                  return val;
                                })
                                .join(
                                  '<span style="color: #0265FF;">' +
                                    this.state.key +
                                    "</span>"
                                ),
                            }}
                          ></span>
                        </div>
                        <span
                          className={"right-entry-title"}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.onSelectEntry(data);
                          }}
                        >
                          {this.findEntryWidget(data) ? (
                            <i className="icon-bsy-select" />
                          ) : (
                            <i className="icon-bsy-check2" />
                          )}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            {seachDashs.length > 0 && (
              <div className="entry-item-title">
                <span
                  className="entry-title"
                  style={{
                    paddingLeft: "20px",
                    height: "36px",
                    lineHeight: "36px",
                  }}
                >
                  {React.language("dash")}
                </span>

                {seachDashs.map((data) => {
                  return (
                    <div
                      className={"applist-item "}
                      key={`seach-dash-${data._id}`}
                    >
                      <div className="app-title">
                        <div className="left-entry">
                          <i
                            className={
                              "entry-icon " + BsyUtils.getFormIcon(data)
                            }
                          />
                          <span
                            className={"entry-title"}
                            dangerouslySetInnerHTML={{
                              __html: data.name
                                .split(this.state.key)
                                .map((val) => {
                                  return val;
                                })
                                .join(
                                  '<span style="color: #0265FF;">' +
                                    this.state.key +
                                    "</span>"
                                ),
                            }}
                          ></span>
                        </div>
                        <span
                          className={"right-entry-title"}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.onSelectEntry(data);
                          }}
                        >
                          {this.findEntryWidget(data) ? (
                            <i className="icon-bsy-select" />
                          ) : (
                            <i className="icon-bsy-check2" />
                          )}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  render() {
    const { key, isLoading } = this.state;
    return (
      <div className={"dashboard-custom-favorites-config"}>
        <div className={"left-app-list"}>
          <div className="applist-seach">
            <BsySearchInput
              placeholder={React.language("form.search.placeholder")}
              getValue={this.getSearchValue}
              onSearch={this.onSearch}
              type={window.mode}
              // iconName="icon-bsy-reportmenu-0"
            />
          </div>
          <div className="applist">
            {!key ? this.renderApplist() : this.renderSeachlist()}
            {isLoading && <BsySLoading />}
          </div>
        </div>
      </div>
    );
  }
}
